import { BaseTransport, HeadTransport } from '../transports'
import { RequestUserConfig } from '../common/types'
import { NetworkService } from '../services'

class HeadClient {
    public getSRLHead({
        user,
        filter,
    }: {
        user: RequestUserConfig
        filter: string
    }): Promise<BaseTransport<HeadTransport>> {
        const headers = {
            'x-language': user.language,
            'x-domain': user.domain,
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.get({
            url: '/api/v1/head/srl-page',
            headers,
            params: { filter },
        })
    }
}

export default new HeadClient()
